var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "emd-text stone-rebrand-footer eu-py_2" }, [
        _c(
          "a",
          {
            staticClass: "_type_outline _active stone-rebrand-footer__item",
            attrs: {
              href: _vm.secureEnvUrl,
              target: "_blank",
              rel: "noopener noreferrer",
            },
          },
          [
            _c("logo-stone-rebrand-icon", {
              staticClass: "stone-rebrand-footer-icon",
            }),
            _c("span", { staticClass: "emd-text _color_default" }, [
              _vm._v("Stone"),
            ]),
          ],
          1
        ),
        _c("span", { staticClass: "emd-text _color_nonessential" }, [
          _vm._v("|"),
        ]),
        _c("span", { staticClass: "stone-rebrand-footer__item" }, [
          _vm._m(0),
          _vm._v(" " + _vm._s(_vm.$t("secureEnvironment")) + " "),
        ]),
      ]),
      _c("emd-footer-internal", {
        attrs: {
          switchLanguage: _vm.switchLanguage,
          switchThemeMode: _vm.switchThemeMode,
          privacySecurity: _vm.privacySecurity,
          help: _vm.help,
          termsOfUse: _vm.termsOfUse,
          privacyPolicy: _vm.privacyPolicy,
          secureEnv: _vm.secureEnv,
          documentation: _vm.documentation,
          status: _vm.status,
          listStyle: _vm.listStyle,
        },
        on: {
          changeLanguage: _vm.changeLanguage,
          changeThemeMode: _vm.changeThemeMode,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "emd-text _color_secondary" }, [
      _c("i", { staticClass: "uil uil-shield-check" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }